export default "__VITE_ASSET__DaqIMx40__"